module.exports = __webpack_public_path__ + "static/media/upload_folder_icon.66912619.svg";